import SyntheseEntityDetailController from './syntheseentity.detail.controller';

export default {
    template: require('./syntheseentity.detail.html'),
    controller: SyntheseEntityDetailController
};
